import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12.59 1.86H3.77a2.21 2.21 0 0 0-2.19 1.9.36.36 0 0 0 0 .1 1.77 1.77 0 0 0 0 .23v9.51a.73.73 0 0 0 .42.67.8.8 0 0 0 .33.08.75.75 0 0 0 .47-.17l3-2.45h6.81a2.23 2.23 0 0 0 2.22-2.22V4.09a2.23 2.23 0 0 0-2.24-2.23Zm.72 7.65a.72.72 0 0 1-.72.72H5.36a.42.42 0 0 0-.15 0 .53.53 0 0 0-.1.06L5 10.4h-.06L3.05 12V4.09a.73.73 0 0 1 .72-.73h8.82a.73.73 0 0 1 .72.73ZM1.56 3.86a1.77 1.77 0 0 0 0 .23V4a.34.34 0 0 1 0-.14Z';
const draw24px =
  'M18,4.31H6A2.75,2.75,0,0,0,3.27,6.75a.28.28,0,0,0,0,.09,1.62,1.62,0,0,0,0,.22V20a.76.76,0,0,0,.43.68.71.71,0,0,0,.32.07.78.78,0,0,0,.48-.17l4.16-3.39H18a2.75,2.75,0,0,0,2.75-2.75V7.06A2.75,2.75,0,0,0,18,4.31Zm1.25,10.13A1.25,1.25,0,0,1,18,15.69H8.23a.66.66,0,0,0-.27.12l0,0L4.75,18.42V7.06A1.25,1.25,0,0,1,6,5.81H18a1.25,1.25,0,0,1,1.25,1.25Zm-16-7.6a1.62,1.62,0,0,0,0,.22V6.9A.13.13,0,0,1,3.26,6.84Zm5.12,8.85H8.23a.6.6,0,0,1,.23,0Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const SpeechBubbleIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'speechBubble'),
) as IconWithRender;

SpeechBubbleIcon.displayName = 'SpeechBubbleIcon';
SpeechBubbleIcon.propTypes = Icon.propTypes;
SpeechBubbleIcon.renderIcon = (props) => <SpeechBubbleIcon {...props} />;
export default SpeechBubbleIcon;
